import { tv, type VariantProps } from "tailwind-variants";

export const toastVariant = tv({
  slots: {
    base: [
      "p-4",
      "bg-background-neutral-inverse border border-border-neutral-strong text-white",
      "rounded-2xl overflow-hidden",
    ],
    description: ["flex items-center gap-2 text-text-neutral-inverse"],
    viewport: [
      "fixed bottom-0 right-0",
      "flex flex-col p-4 gap-2 w-sm m-0",
      "list-none z-[2147483001] outline-none pointer-events-none",
    ],
  },
  variants: {},
  defaultVariants: {},
});

export type ToastVariantProps = VariantProps<typeof toastVariant>;
export type ToastReturnVariantProps = ReturnType<typeof toastVariant>;
